import { Controller } from 'stimulus';
import ProgressBar from 'progressbar.js'; // eslint-disable-line import/no-unresolved, import/extensions
import { triggerCustomEvent, initSvgAnim } from 'lib/helpers';
import events from 'lib/events';

import checkmarkAnimationData from 'lib/animation-data/checkmark-light-animation-data';

export default class DownloadPopupController extends Controller {
  static targets = [
    'timer',
    'count',
    'animContainer',
    'adWrap',
    'adTemplate',
  ];

  connect() {
    this.count = parseInt(this.countTarget.innerHTML, 10);
    this.downloadFileUrl = this.element.dataset.downloadFileUrl;
    this.initAd();
    this.setupAdCountdown();

    triggerCustomEvent(events.show_page.download_ad_modal_connects, {});
  }


  initAd() {
    const adTemplate = this.adTemplateTarget.innerHTML;

    this.adWrapTarget.insertAdjacentHTML('beforeend', adTemplate);
  }

  setupAdCountdown() {
    // We need to add an extra second at the beginning
    // so we see the first number count down
    setTimeout(() => {
      this.dlAdCountdown();
    }, 1000);

    const dlAdTimer = new ProgressBar.Circle('[data-target="download-popup.timer"]', {
      strokeWidth: 7,
      easing: 'easeInOut',
      duration: 5000,
      color: '#999999',
      trailColor: '#cccccc',
      trailWidth: 7,
      svgStyle: null,
    });

    dlAdTimer.animate(1.0); // Number from 0.0 to 1.0
  }

  dlAdCountdown = () => {
    if (Number.isNaN(this.count)) {
      this.setUpAdFinish();

      triggerCustomEvent('TriggerDownload', { downloadFileUrl: this.downloadFileUrl });
    } else {
      this.count = this.count - 1;

      if (this.count < 0) {
        this.setUpAdFinish();

        triggerCustomEvent('TriggerDownload', { downloadFileUrl: this.downloadFileUrl });
      } else {
        this.countTarget.innerHTML = this.count;

        setTimeout(this.dlAdCountdown, 1000);
      }
    }
  }

  setUpAdFinish() {
    this.element.closest('#download-popup-modal').classList.remove('is-counting-down');

    const header = this.element.querySelector('.download-popup__header');
    header.innerHTML = header.dataset.started;
    this.element.classList.add('is-complete');

    if (!this.animContainerTarget.querySelector('svg')) {
      initSvgAnim(this.animContainerTarget, JSON.parse(checkmarkAnimationData));
    }
  }
}
